/**
 * Team ids. Neutral things (scarecrows, pickups) can be hit by everyone and attack no one. A war map has two teams (blue
 * west, red east).
 */
export const Team = { Neutral: 0, Blue: 1, Red: 2 } as const;
export type Team = (typeof Team)[keyof typeof Team];

export const TEAMS = [Team.Blue, Team.Red] as const;

const teamsByBases = new WeakMap<readonly { team: number }[], readonly number[]>();

/** The teams a map is played by: its bases' teams, in team order (none on a map without bases). Worked out once a map. */
export const teamsOf = (map: { bases: readonly { team: number }[] }): readonly number[] => {
  let teams = teamsByBases.get(map.bases);
  if (!teams) {
    teams = [...new Set(map.bases.map((b) => b.team))].sort((a, b) => a - b);
    teamsByBases.set(map.bases, teams);
  }
  return teams;
};

/** True when `a` may damage `b` (no friendly fire; neutral targets are fair game). */
export const canDamage = (a: number, b: number): boolean => a === Team.Neutral || b === Team.Neutral || a !== b;

export const TEAM_NAMES: Record<number, string> = { 0: 'neutral', 1: 'blue', 2: 'red' };
